export const ADMIN_ACCESS = {
  FULL: 'Full Access',
  PARTIAL: 'Partial Access',
};
